import React, { useState, useRef, useEffect } from 'react';
import { Box, Container, Toolbar, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AppBarComponent } from '@/components/layout/AppBarComponent';
import { Sidebar } from '@/components/layout/Sidebar';
import { useViewPort } from '@/hooks';

// const DRAWER_WIDTH_COLLAPSED = 64;
const DRAWER_WIDTH = 240;
export const DashboardLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isMobile } = useViewPort();
  const pageContentRef = useRef<HTMLDivElement>(null);

  const handleMobileMenuToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileMenuClose = () => {
    setMobileOpen(false);
  };

  // Height logging effect
  useEffect(() => {
    const logPageContentHeight = () => {
      if (pageContentRef.current) {
        const height = pageContentRef.current.clientHeight;
        const scrollHeight = pageContentRef.current.scrollHeight;
        const offsetHeight = pageContentRef.current.offsetHeight;
        
        console.log('📐 Page Content Height Measurements:', {
          clientHeight: height,
          scrollHeight: scrollHeight,
          offsetHeight: offsetHeight,
          availableHeight: `${height}px`,
          timestamp: new Date().toLocaleTimeString()
        });
      }
    };

    // Log height on mount and when window resizes
    logPageContentHeight();
    window.addEventListener('resize', logPageContentHeight);
    
    // Also log after a short delay to catch layout changes
    const timeoutId = setTimeout(logPageContentHeight, 100);

    return () => {
      window.removeEventListener('resize', logPageContentHeight);
      clearTimeout(timeoutId);
    };
  }, [isMobile]); // Re-run when mobile state changes

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* AppBar */}
      <AppBarComponent onMobileMenuToggle={handleMobileMenuToggle} />

      {/* Sidebar */}
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={handleMobileMenuClose}
      />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          position: 'fixed',
          top: 0,
          left: {
            xs: 0,
            sm: `${DRAWER_WIDTH + 16}px`, // Fixed position - never changes
          },
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        {/* Toolbar spacing */}
        <Toolbar />
        
        {/* Page Content */}
        <Box
          ref={pageContentRef}
          sx={{
            flexGrow: 1,
            px: isMobile?0: 3,
            pt:2,
            py:2
          }}
        >
          <Container maxWidth="xl" sx={{ height: '99%' }}>
            <Paper
              elevation={0}
              sx={{
                px: {xs: isMobile?2:0,  sm:isMobile?2:0 , md:3.5},
                py: {xs: isMobile?2:0,  sm:isMobile?2:0 , md:3},
                borderRadius: 2,
                minHeight: 'calc(100vh - 100px)',
                bgcolor: 'background.paper',
              }}
            >
              <Outlet />
            </Paper>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};